import React from 'react'
import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {MdSentimentDissatisfied as DissatisfiedFace} from 'react-icons/md'
import Text from '@daedalus/atlas/src/components/designSystem/Text'
import ContentWrapper from '@daedalus/atlas/src/components/designSystem/helpers/ContentWrapper'

interface ErrorBannerProps {
  /** The title for the banner. It appears as a heading */
  title: React.ReactNode
  /** The longer description of the error. Should give enough details for the user. */
  description: React.ReactNode
}

const ICON_SIZE = 16

const ErrorBannerWrapper = styled('div')(
  ({theme}) => css`
    border: 1px solid ${theme.colors.coral.c300};
    background-color: ${theme.colors.coral.c100};
    border-radius: ${theme.layout.radius.md}px;
    padding: ${theme.layout.spacing.s400}px;
    display: flex;
    flex-wrap: nowrap;
  `
)

const DissatisfiedFaceStyled = styled(DissatisfiedFace)(
  ({theme}) => css`
    color: ${theme.colors.coral.c600};
    height: 24px;
  `
)

const TitleStyled = styled(Text)(
  ({theme}) => css`
    line-height: ${theme.fonts.lineHeight.lg};
  `
)

export const ErrorBanner = ({title, description}: ErrorBannerProps) => {
  return (
    <ErrorBannerWrapper>
      <DissatisfiedFaceStyled size={ICON_SIZE} />
      <ContentWrapper paddingSize="s000" paddingLeftSize="s300">
        <TitleStyled appearance="subtitle2">{title}</TitleStyled>
        <Text appearance="small">{description}</Text>
      </ContentWrapper>
    </ErrorBannerWrapper>
  )
}
